<template>
  <div>
    <v-card>
      <img class="text-md-center" alt="logo" src="/static/img/dfs-logo.png" srcset="/static/img/dfs-logo@2x.png 2x">
    </v-card>
  </div>
</template>

<script>
  export default {
    mounted () {
      console.log(this.$vuetify.breakpoint)
    }
  }
</script>



// WEBPACK FOOTER //
// Home.vue?0d7642e8